import axios from "axios";
import { Message } from "element-ui";
import router from '@/router' 


let apiBaseUrl;
if (process.env.NODE_ENV === "development") {
  // 开发环境走代理（无需修改代码）
  apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
  console.log("开发", apiBaseUrl);
} else {
  apiBaseUrl = window._CONFIG["domianURL"] || process.env.VUE_APP_API_BASE_URL;
}
const request = axios.create({
  baseURL: apiBaseUrl,
  timeout: 60000,
});

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["X-Access-Token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (res) => {
    const { code, message, data } = res.data;
    if (code === 200) {
      return res.data;
    }
    Message.error(data,200,'res');
    return res.data;
  },
  (error) => {
    console.log(error);
    if(error.response.data == 'loginOut'){
      console.log(error.response.data);
      localStorage.removeItem('token');
      router.push("/");
    }
    const msg = error.response?.data?.message || error.message || "网络异常";
    Message.error(msg);
    // 同样返回统一格式，方便调用端判断
    return { code: -1, message: msg, data: null };
  }
);

export default request;
